// Clock-in Integration Configuration
// Update these settings to match your internal website's API

export const CLOCK_IN_CONFIG = {
  // Base URL for your internal website's API
  API_BASE_URL: process.env.REACT_APP_CLOCK_IN_API_URL || 'https://your-internal-website.com/api',
  
  // API Key for authentication (if required)
  API_KEY: process.env.REACT_APP_CLOCK_IN_API_KEY || '',
  
  // Polling interval in milliseconds (default: 30 seconds)
  POLLING_INTERVAL: parseInt(process.env.REACT_APP_CLOCK_IN_POLLING_INTERVAL) || 30000,
  
  // API endpoints
  ENDPOINTS: {
    // Get clock-in status for all staff
    GET_ALL_STATUS: '/clock-in-status',
    
    // Get clock-in status for specific staff members
    GET_BATCH_STATUS: '/clock-in-status/batch',
    
    // Update clock-in status for a specific staff member
    UPDATE_STATUS: '/clock-in-status/:staffLogin',
  },
  
  // Status mappings from your internal website to app status values
  STATUS_MAPPINGS: {
    // Map your internal status values to app status values
    'clocked_in': 'orange',           // Clocked-In
    'at_station': 'green',            // At Station (LEO)
    'at_station_override': 'light-green', // At Station (Override)
    'not_clocked_in': 'red',          // Not Clocked-In
    'off_duty': 'red',                // Not Clocked-In
    'break': 'orange',                // Clocked-In
    'training': 'orange',             // Clocked-In
    'lunch': 'orange',                // Clocked-In
    'meeting': 'orange',              // Clocked-In
    'maintenance': 'orange',          // Clocked-In
    'problem_solve': 'orange',        // Clocked-In
    'indirect': 'orange',             // Clocked-In
    'direct': 'green',                // At Station (LEO)
    'override': 'light-green',        // At Station (Override)
    
    // Add more mappings as needed for your specific status values
  },
  
  // Request headers
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  
  // Error handling
  ERROR_HANDLING: {
    // Maximum number of consecutive failures before stopping polling
    MAX_CONSECUTIVE_FAILURES: 5,
    
    // Retry delay in milliseconds after a failure
    RETRY_DELAY: 5000,
    
    // Whether to continue polling even if there are errors
    CONTINUE_ON_ERROR: true,
  },
  
  // Logging
  LOGGING: {
    // Enable/disable console logging
    ENABLE_LOGS: process.env.NODE_ENV === 'development',
    
    // Log level: 'error', 'warn', 'info', 'debug'
    LOG_LEVEL: 'info',
  },
};

// Helper function to get the full API URL for an endpoint
export const getApiUrl = (endpoint, params = {}) => {
  let url = `${CLOCK_IN_CONFIG.API_BASE_URL}${endpoint}`;
  
  // Replace URL parameters
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Helper function to get headers with authentication
export const getHeaders = () => {
  const headers = { ...CLOCK_IN_CONFIG.HEADERS };
  
  if (CLOCK_IN_CONFIG.API_KEY) {
    headers['Authorization'] = `Bearer ${CLOCK_IN_CONFIG.API_KEY}`;
  }
  
  return headers;
};

// Helper function to map external status to app status
export const mapStatus = (externalStatus) => {
  if (!externalStatus) return 'red';
  
  const status = externalStatus.toLowerCase().trim();
  return CLOCK_IN_CONFIG.STATUS_MAPPINGS[status] || 'red';
};

// Helper function to log messages based on configuration
export const log = (level, message, ...args) => {
  if (!CLOCK_IN_CONFIG.LOGGING.ENABLE_LOGS) return;
  
  const levels = ['error', 'warn', 'info', 'debug'];
  const configLevel = levels.indexOf(CLOCK_IN_CONFIG.LOGGING.LOG_LEVEL);
  const messageLevel = levels.indexOf(level);
  
  if (messageLevel <= configLevel) {
    console[level](`[Clock-In Service] ${message}`, ...args);
  }
}; 